import { useCallback } from 'react';
import { AddCustomItemModal } from '@/components/modals/AddCustomItemModal';

export interface AddCustomViolationTypeModalProps {
  open: boolean;
  theme?: string;
  onSave: (data: { violationTypeValue: string }) => void;
  onCancel: () => void;
}

export function AddCustomViolationTypeModal({
  open,
  theme,
  onSave,
  onCancel,
}: AddCustomViolationTypeModalProps) {
  const handleSave = useCallback((value: string) => {
    onSave({ violationTypeValue: value });
  }, [onSave]);

  return (
    <AddCustomItemModal
      open={open}
      title="Add Custom Violation Type"
      fieldLabel="Violation Type"
      placeholder="Enter violation type..."
      requiredMessage="Violation type required."
      inputClassName="kstc-input kst-violation-type-input"
      maxLength={255}
      theme={theme}
      onSave={handleSave}
      onCancel={onCancel}
    />
  );
}

(window as any).AddCustomViolationTypeModalReact = AddCustomViolationTypeModal;
